export default "__VITE_ASSET__ClvOo22$__"